import request, { APICall } from "../request";
import { HubspotLeadSourcesResponse, HubspotLenderType } from "./types";

export const getHubspotLeadSources = (): APICall<HubspotLeadSourcesResponse> =>
  request({ url: "/hubspot/lead-sources", method: "GET" });

export const getHubspotLenders = (): APICall<{ data: HubspotLenderType[] }> =>
  request({
    url: `/hubspot/lenders`,
    method: "GET",
  });
